// Copyright (c) 2017 Deere & Company

import busyCounter from '../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import isMoreSummaryVisible from './show-more-groups-visibility';
import isVisible from './labor-additive-summary-modal-visibility';
import laborAdditiveSummaries from './labor-additive-summaries';
import laborAdditiveSummary from './labor-additive-summary';
import notifications from './notifications';
import searchByDropDown from './search-by-dropdown';
import searchQueryString from './search-query-string';
import wip from './wip';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    isMoreSummaryVisible,
    isVisible,
    laborAdditiveSummaries,
    laborAdditiveSummary,
    notifications,
    searchByDropDown,
    searchQueryString,
    wip
});



// WEBPACK FOOTER //
// ./src/home-page/reducers/index.js